import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
}), 'BrandingWatermark');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BrandingWatermark.js
// module id = 2468
// module chunks = 2